
import PrismicData from '~/assets/js/prismic-controller.js'
export default {
  name: 'FAQSingle',
  layout: 'faq',
  async asyncData({ $prismic, app, params, error, req, store }) {
    const lang = app.i18n.locales.filter((i) =>
      i.iso.includes(app.i18n.locale)
    )[0].iso
    try {
      const faq = await $prismic.api.getByUID('faq', params.uid, { lang })
      const section = await $prismic.api.getByUID('faq_section', faq.data.section.uid, { lang })

      function getAltLangNav(altLanguages) {
        return altLanguages.reduce((a, item) => {
          const lang = item.lang.substr(0, 2)
          const sectionUid = section.alternate_languages.find(s => s.lang === item.lang).uid
          a[lang] = {
            uid: item.uid,
            section: sectionUid,
            product: faq.data.product
          }
          return a
        },{})
      }
      if (faq.alternate_languages.length) {
        const altLang = getAltLangNav(faq.alternate_languages)
        store.dispatch('i18n/setRouteParams', altLang)
      }

      return { faq, documentLang: faq.lang.substr(0, 2) }
    } catch (e) {
      error({ message: JSON.stringify(e), statusCode: 404 })
    }
  },
  head() {
    return PrismicData.seo(this.$nuxtI18nHead({ addSeoAttributes: true }), 
      {...this.faq, seo_title: this.faq.data.question[0].text + ' - Vitesy FAQ', content: this.faq.data.answer},
      'faq/' + this.faq.data.section.uid + '/' + this.faq.uid,
      this.documentLang,
      this.faq.uid
    )
  },
}
